import { Card } from "@/components/ui/card";
import { BarChart3, Hash, TrendingUp, Users } from "lucide-react";

interface StatsOverviewProps {
  totalGenerations: number;
  totalNumbers: number;
  uniqueUsers: number;
  avgPerGeneration: number;
}

export const StatsOverview = ({ 
  totalGenerations, 
  totalNumbers, 
  uniqueUsers,
  avgPerGeneration 
}: StatsOverviewProps) => {
  const stats = [
    {
      icon: Hash,
      label: "Total Numbers Generated",
      value: totalNumbers.toLocaleString(),
      color: "text-primary"
    },
    {
      icon: BarChart3,
      label: "Total Generations",
      value: totalGenerations.toLocaleString(),
      color: "text-accent"
    },
    {
      icon: Users,
      label: "Unique Sessions",
      value: uniqueUsers.toLocaleString(),
      color: "text-secondary"
    },
    {
      icon: TrendingUp,
      label: "Avg Per Generation",
      value: avgPerGeneration.toFixed(1),
      color: "text-muted-foreground"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <Card key={stat.label} className="p-6">
            <div className="flex items-center gap-3 mb-2">
              <Icon className={`w-5 h-5 ${stat.color}`} />
              <span className="text-sm text-muted-foreground">{stat.label}</span>
            </div>
            <div className="text-3xl font-bold text-foreground">{stat.value}</div>
          </Card>
        );
      })}
    </div>
  );
};
